module.exports = __webpack_public_path__ + "img/Shower.02acd679.png";